import { createSmileExpressionFrames } from "./expression-keyframes.js";

/**
 * Story sequence: hop while the hole opens, fall through it, peek and scan,
 * jump-scare, then smile.
 */
export function createHideSurpriseFrames() {
  const expression = createSmileExpressionFrames({
    enterStart: .845,
    enterCross: .86,
    enterEnd: .875,
    exitStart: .955,
    exitCross: .968,
    exitEnd: .98,
    settleEnd: .99,
    smileHoldFrames: [
      { opacity: 1, transform: "scale(1.08, 1.08) translateY(-1px)", offset: .91 },
      { opacity: 1, transform: "scale(1, 1) translateY(0)", offset: .945 },
    ],
  });

  return {
    body: [
      { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 0 },
      { transform: "translateY(6px) scale(1.12, .84) rotate(0deg)", offset: .035, easing: "cubic-bezier(.4,0,.75,.35)" },
      { transform: "translateY(-8px) scale(.93, 1.12) rotate(-1deg)", offset: .075, easing: "cubic-bezier(.12,.72,.22,1)" },
      { transform: "translateY(-46px) scale(.96, 1.08) rotate(-1.6deg)", offset: .12, easing: "cubic-bezier(.16,.72,.24,1)" },
      { transform: "translateY(-58px) scale(.99, 1.02) rotate(-.6deg)", offset: .155, easing: "cubic-bezier(.45,0,.78,.38)" },
      { transform: "translateY(-50px) scale(1, 1.01) rotate(.2deg)", offset: .185, easing: "cubic-bezier(.55,.02,.9,.5)" },
      { transform: "translateY(-10px) scale(.98, 1.05) rotate(.5deg)", offset: .215, easing: "cubic-bezier(.58,.02,.92,.48)" },
      { transform: "translateY(34px) scale(.94, 1.10) rotate(0deg)", offset: .235, easing: "cubic-bezier(.64,0,.96,.42)" },
      { transform: "translateY(225px) scale(.90, 1.16) rotate(0deg)", offset: .255 },
      { transform: "translateY(225px) scale(.90, 1.16) rotate(0deg)", offset: .275 },
      { transform: "translateY(105px) scale(.98, 1.02) rotate(0deg)", offset: .34, easing: "cubic-bezier(.16,1,.3,1)" },
      { transform: "translateY(99px) scale(1, 1) rotate(0deg)", offset: .38, easing: "cubic-bezier(.16,1,.3,1)" },
      { transform: "translateY(99px) scale(1, 1) rotate(0deg)", offset: .58 },
      { transform: "translateY(150px) scale(1.11, .89) rotate(0deg)", offset: .62, easing: "cubic-bezier(.45,0,.8,.35)" },
      { transform: "translateY(-124px) scale(.90, 1.14) rotate(-2deg)", offset: .70, easing: "cubic-bezier(.4,0,.8,.45)" },
      { transform: "translateY(-92px) scale(.95, 1.08) rotate(1.2deg)", offset: .735, easing: "cubic-bezier(.45,0,.88,.42)" },
      { transform: "translateY(6px) scale(1.20, .80) rotate(0deg)", offset: .775, easing: "cubic-bezier(.12,.78,.24,1)" },
      { transform: "translateY(-18px) scale(.97, 1.06) rotate(-.8deg)", offset: .81, easing: "cubic-bezier(.12,.78,.24,1)" },
      { transform: "translateY(1px) scale(1.06, .94) rotate(.4deg)", offset: .84 },
      { transform: "translateY(-7px) scale(.99, 1.03) rotate(-.3deg)", offset: .875, easing: "cubic-bezier(.16,.78,.3,1)" },
      { transform: "translateY(0) scale(1.015, .99) rotate(0deg)", offset: .925 },
      { transform: "translateY(0) scale(1.015, .99) rotate(0deg)", offset: .965 },
      { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 1, easing: "cubic-bezier(.16,1,.3,1)" },
    ],
    shadow: [
      { transform: "scaleX(1)", opacity: .28, offset: 0 },
      { transform: "scaleX(1.18)", opacity: .38, offset: .035 },
      { transform: "scaleX(.76)", opacity: .19, offset: .075 },
      { transform: "scaleX(.44)", opacity: .08, offset: .12 },
      { transform: "scaleX(.34)", opacity: .045, offset: .155 },
      { transform: "scaleX(.42)", opacity: .07, offset: .185 },
      { transform: "scaleX(.82)", opacity: .18, offset: .215 },
      { transform: "scaleX(1.08)", opacity: .31, offset: .235 },
      { transform: "scaleX(.18)", opacity: 0, offset: .255 },
      { transform: "scaleX(.18)", opacity: 0, offset: .275 },
      { transform: "scaleX(1.05)", opacity: .24, offset: .34 },
      { transform: "scaleX(1.02)", opacity: .22, offset: .58 },
      { transform: "scaleX(1.30)", opacity: .40, offset: .62 },
      { transform: "scaleX(.24)", opacity: .04, offset: .70 },
      { transform: "scaleX(.42)", opacity: .10, offset: .735 },
      { transform: "scaleX(1.40)", opacity: .47, offset: .775 },
      { transform: "scaleX(.70)", opacity: .16, offset: .81 },
      { transform: "scaleX(1.14)", opacity: .35, offset: .84 },
      { transform: "scaleX(.86)", opacity: .22, offset: .875 },
      { transform: "scaleX(1.04)", opacity: .30, offset: .925 },
      { transform: "scaleX(1)", opacity: .28, offset: 1 },
    ],
    eyes: [
      { transform: "translateX(0px) scale(1, 1)", offset: 0 },
      { transform: "translateX(0px) scale(1, 1)", offset: .34 },
      { transform: "translateX(-4px) scale(.98, .95)", offset: .40, easing: "cubic-bezier(.16,1,.3,1)" },
      { transform: "translateX(-4px) scale(.98, .95)", offset: .44 },
      { transform: "translateX(4px) scale(1.02, 1)", offset: .49, easing: "cubic-bezier(.16,1,.3,1)" },
      { transform: "translateX(4px) scale(1.02, 1)", offset: .53 },
      { transform: "translateX(0px) scale(1, .92)", offset: .58, easing: "cubic-bezier(.16,1,.3,1)" },
      { transform: "translateX(0px) scale(1, 1)", offset: .62 },
      { transform: "translateX(0px) scale(1.15, 1.20)", offset: .70, easing: "cubic-bezier(.08,.78,.18,1)" },
      { transform: "translateX(0px) scale(1.20, 1.24)", offset: .775 },
      { transform: "translateX(0px) scale(1.04, 1.04)", offset: .845 },
      { transform: "translateX(0px) scale(1, 1)", offset: 1 },
    ],
    blink: [
      { transform: "scaleY(1)", offset: 0 },
      { transform: "scaleY(1)", offset: 1 },
    ],
    openEyes: expression.openEyes,
    smileEyes: expression.smileEyes,
    glow: [
      { opacity: .48, offset: 0 },
      { opacity: .54, offset: .12 },
      { opacity: .58, offset: .155 },
      { opacity: .42, offset: .215 },
      { opacity: .22, offset: .255 },
      { opacity: .22, offset: .275 },
      { opacity: .54, offset: .38 },
      { opacity: .56, offset: .58 },
      { opacity: .42, offset: .62 },
      { opacity: .86, offset: .70 },
      { opacity: .92, offset: .775 },
      { opacity: .74, offset: .84 },
      { opacity: .48, offset: 1 },
    ],
    holeBack: [
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: 0 },
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: .11 },
      { opacity: .58, transform: "translateX(-50%) scaleX(.58)", offset: .13 },
      { opacity: 1, transform: "translateX(-50%) scaleX(1)", offset: .16, easing: "cubic-bezier(.16,1,.3,1)" },
      { opacity: 1, transform: "translateX(-50%) scaleX(1)", offset: .705 },
      { opacity: .46, transform: "translateX(-50%) scaleX(.60)", offset: .72, easing: "cubic-bezier(.55,0,.9,.45)" },
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: .74, easing: "cubic-bezier(.55,0,.9,.45)" },
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: 1 },
    ],
    holeFront: [
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: 0 },
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: .11 },
      { opacity: .50, transform: "translateX(-50%) scaleX(.54)", offset: .13 },
      { opacity: 1, transform: "translateX(-50%) scaleX(1)", offset: .165, easing: "cubic-bezier(.16,1,.3,1)" },
      { opacity: 1, transform: "translateX(-50%) scaleX(1)", offset: .705 },
      { opacity: .40, transform: "translateX(-50%) scaleX(.56)", offset: .72, easing: "cubic-bezier(.55,0,.9,.45)" },
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: .74, easing: "cubic-bezier(.55,0,.9,.45)" },
      { opacity: 0, transform: "translateX(-50%) scaleX(.18)", offset: 1 },
    ],
    groundCover: [
      { opacity: 0, transform: "translateY(4px)", offset: 0 },
      { opacity: 0, transform: "translateY(4px)", offset: .115 },
      { opacity: 1, transform: "translateY(0)", offset: .16, easing: "cubic-bezier(.16,1,.3,1)" },
      { opacity: 1, transform: "translateY(0)", offset: .705 },
      { opacity: 0, transform: "translateY(3px)", offset: .74, easing: "cubic-bezier(.55,0,.9,.45)" },
      { opacity: 0, transform: "translateY(3px)", offset: 1 },
    ],
  };
}
